module.exports = __webpack_public_path__ + "img/免费.9cbb099f.png";